import PropTypes from 'prop-types';
import React from 'react';
import { Button, ProgressBar, Dialog, Checkbox } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';
import Tree from "../concord/Tree.js";
import TextSelector from 'text-selection-react';
import './KwicTable.css';
import ReactAudioPlayer from 'react-audio-player';

class Context extends React.PureComponent {

  state = {
    displayTree:false,
    treeSvg:null,
    treeQuery:null,
    query:null,
    waitingSuggestion:false,
  }
  componentWillUnmount(){
    // when closing the context windows, TextSelector events must be cleared
    document.onmouseup=null;
    document.onmousedown=null;
  }


  toggleModal = () => {
    this.setState(prevState => ({ displayTree: !prevState.displayTree}));
  }

  fetchTree = (selectedText) => {
    // building a temporary fileName for first temporary Result
    const tmpName=Date.now().toString()+"_"+Math.random(100).toString()+".json";
    //console.log("innerText=",selectedText.innerText);
    const data = {
      query: selectedText.innerText.trim(),
      fileId: this.props.fileId,
      collection: this.props.collection,
      language: this.props.language,
      intervalSentNum: this.props.intervalSentNum,
      tmpName: tmpName,
      lemmatizeExample:true
    }; 
    if (this.props.params) {
      data.params = this.props.params;
    }

    this.setState({ query:selectedText.innerText, displayTree:true, waitingSuggestion:true });

    const endpoint = '/get_examples.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        this.setState({ waitingSuggestion:false });
        return;
      }
      res.json().then(data => {
        if (data.examples ) {
          if (data.examples.length>0 && data.examples[0].svg) {
            this.setState({ treeSvg: data.examples[0].svg, treeQuery:data.examples[0].query, displayTree:true, waitingSuggestion:false });
          } else {
            this.setState({ treeSvg: "not found", treeQuery:null, displayTree:true, waitingSuggestion:false });
          }
          // console.log("trouvé");
        } else {
          this.setState({ waitingSuggestion:false });
          // console.log("pas trouvé");
        }
      }).catch(() => {
        // console.log('json pas lisible');
      })
    })
    .catch(() => {
      this.setState({ waitingSuggestion:false });
      console.log(`Network error when trying to fetch ${endpoint}`);
    })
  }

  render() {
    const { t } = this.props;
    const { aligned_sentences } = this.props.concordDetail;
    const cl =  (aligned_sentences)? "flex-two-panels":"";
    var { sentence, left_context, right_context, aligned_left_context, aligned_right_context} = this.props.concordDetail;
    
    const wavUrl=this.props.concordDetail.metadata.audioLink;

    if (! this.props.displayS) {
      left_context=left_context? left_context.replace(/&lt;s&gt;/g,""): "";
      right_context=right_context? right_context.replace(/&lt;s&gt;/g,""): "";
      sentence=sentence? sentence.replace(/&lt;s&gt;/g,""): "";
      aligned_left_context=aligned_left_context? aligned_left_context.replace(/&lt;s&gt;/g,""): "";
      aligned_right_context=aligned_right_context? aligned_right_context.replace(/&lt;s&gt;/g,""): "";
    }
    return (
      <>
        <div className="flex dialogContainer">
          
            <div className={cl} >
              <TextSelector
                events={[
                    {
                      text:this.props.t('displayTree'),
                      handler: this.fetchTree
                    }
                  ]}
              />
              <span dangerouslySetInnerHTML={{__html:left_context?left_context.replace(/\n|\\n/g,"<br/>"):""}}></span>
              <span style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html:sentence?sentence.replace(/\n/g,"<br/>"):""}}></span>
              <span dangerouslySetInnerHTML={{__html:right_context?right_context.replace(/\n|\\n/g,"<br/>"):""}}></span>
            </div> 
            { !!(aligned_sentences) &&
              <div className={cl+" aligned"}>
                <span dangerouslySetInnerHTML={{__html:aligned_left_context?aligned_left_context.replace(/\n|\\n/g,"<br/>"):""}}></span>
                <span style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html:aligned_sentences?aligned_sentences.replace(/\n/g,"<br/>"):""}}></span>
                <span dangerouslySetInnerHTML={{__html:aligned_right_context?aligned_right_context.replace(/\n|\\n/g,"<br/>"):""}}></span>
              </div>
            }
        </div>
        <br/>
        <div className="flex dialogContainer">
          <Checkbox
            checked={this.props.displayS}
            label={t('displaySentences')}
            onChange={this.props.toggleDisplayS}
          />
        </div>
        { wavUrl  && 
            <div className="flex dialogContainer">
              <ReactAudioPlayer  ref={(element) => { this.rap = element; }} src={wavUrl} controls crossOrigin preload={true} autoPlay={true}/> 
            </div>
         }

        <Dialog
          scroll={'body'}
          isOpen={this.state.displayTree}
          onClose={this.toggleModal}
          title={this.state.query}
          style={{'width':'auto'}}
        > 

          <div style={{paddingTop:20}}>
            { this.state.waitingSuggestion &&
              <ProgressBar/>
            }
            { ! this.state.waitingSuggestion &&
              <>
                <div>
                  <Tree svg={this.state.treeSvg} />
                </div>
                { this.state.treeQuery && 
                  <center>
                    <Button onClick={()=> { 
                                      this.toggleModal();
                                      if (this.props.parentDialogToggleModal) {
                                        //this.props.parentDialogToggleModal();
                                      }
                                      this.props.pasteQuery(this.state.treeQuery)} 
                                    }
                    >
                      {this.props.t('pasteThisQuery')}
                    </Button>
                  </center>
                }
              </>
            }
          </div>

        </Dialog>   
      </>
    );

  }
}

Context.propTypes = {
    concordDetail: PropTypes.object,
    fileId: PropTypes.string,
    collection: PropTypes.string,
    language: PropTypes.string,
    intervalSentNum: PropTypes.string,
    pasteQuery: PropTypes.func,
    displayS: PropTypes.bool,
    toggleDisplayS: PropTypes.func,
    parentDialogToggleModal: PropTypes.func
};

export default withTranslation()(Context);
